import { api } from './api';
import type { EventoCalendario, Funcao } from './escalas';

/** Uma pessoa na escala de lideres de um culto. */
export type EscaladoLideranca = {
  id: number;
  membroId: number;
  nome: string;
  funcao: string;
  funcaoId: number | null;
  status: 'convocado' | 'confirmado' | 'indisponivel' | string;
  justificativa: string | null;
};

export type CultoLideranca = {
  id: number;
  titulo: string;
  tipo: string;
  local: string | null;
  inicio: string | null;
  escalados: EscaladoLideranca[];
  confirmados: number;
  total: number;
};

export type MinisterioLideranca = { id: number; nome: string; funcoes: Funcao[] };

/** Quem pode entrar na escala: vem de Equipes (lider de equipe ou de sub). */
export type Lider = {
  id: number;
  nome: string;
  lidera: { tipo: 'equipe' | 'sub'; nome: string; equipe: string }[];
  temConta: boolean;
  contaAtiva: boolean;
  podeEscalar: boolean;
  /** quantas vezes ja esta na escala de lideres daqui para a frente */
  escalasPelaFrente: number;
};

export const buscarEscalaLideres = (quando: 'proximos' | 'anteriores') =>
  api<{
    ministerio: MinisterioLideranca;
    eventos: CultoLideranca[];
    semConta: { escalaId: number; membroId: number; nome: string }[];
    podeEditar: boolean;
    meuMembroId: number | null;
  }>(`/escala-lideres?quando=${quando}`);

export const buscarCultoLideranca = (eventoId: number) =>
  api<{
    ministerio: MinisterioLideranca;
    evento: CultoLideranca;
    podeEditar: boolean;
    meuMembroId: number | null;
  }>(`/escala-lideres/eventos/${eventoId}`);

export const buscarCalendarioLideranca = (mes: string) =>
  api<{ eventos: EventoCalendario[]; podeEditar: boolean }>(`/escala-lideres/calendario?mes=${mes}`);

export const buscarLideres = () => api<{ lideres: Lider[] }>('/escala-lideres/lideres');

export const escalarLider = (dados: {
  eventoId: number;
  membroId: number;
  funcaoId: number;
  /** so quando o admin viu o aviso de indisponibilidade e decidiu seguir */
  confirmarMesmoAssim?: boolean;
}) => api<{ id: number }>('/escala-lideres', { method: 'POST', body: JSON.stringify(dados) });

/** Conta para um lider sem conta: nasce com papel de lider, ligada a ficha dele. */
export const criarContaDeLider = (membroId: number, dados: { email: string; senha: string }) =>
  api<{ usuarioId: number }>(`/escala-lideres/lideres/${membroId}/conta`, {
    method: 'POST',
    body: JSON.stringify(dados),
  });

export const tirarLider = (escalaId: number) => api(`/escala-lideres/${escalaId}`, { method: 'DELETE' });

/** A propria resposta usa a mesma rota das outras escalas: so o escalado responde. */
export const responderEscala = (
  escalaId: number,
  status: 'confirmado' | 'indisponivel',
  justificativa?: string,
) =>
  api(`/escalas/${escalaId}/responder`, {
    method: 'POST',
    body: JSON.stringify({ status, ...(justificativa ? { justificativa } : {}) }),
  });

/** "Judá" ou "sub Somos Um (Judá)" — para o admin saber quem e quem na lista. */
export function oQueLidera(l: Pick<Lider, 'lidera'>): string {
  return l.lidera
    .map((x) => (x.tipo === 'equipe' ? x.nome : `sub ${x.nome} (${x.equipe})`))
    .join(' · ');
}
